export const SEARCH_PARAMS = {
  account: {
    hasJustUpgradedToProPlan: 'hasJustUpgradedToProPlan',
  },

  addContact: {
    name: 'name',
    tagId: 'tagId',
    returnUrl: 'returnUrl',
  },

  contactDetails: {
    searchQuery: 'searchQuery',
    debouncedSearchQuery: 'searchQueryDebounced',
    page: 'page',
  },

  contactList: {
    searchQuery: 'searchQuery',
    debouncedSearchQuery: 'searchQueryDebounced',
    page: 'page',
  },

  tagDetails: {
    searchQuery: 'searchQuery',
    debouncedSearchQuery: 'searchQueryDebounced',
    page: 'page',
  },

  shared: {
    returnUrl: 'returnUrl',
  },
}
